import { Signal } from '@preact/signals-react';

import { AiComponentTab } from '@/features/editor/widgets/shared/ai-editing-layout/types';

export interface UIStateActions {
  selectTab: (tab: AiComponentTab) => void;
  onSelectedCodeTab: (tab: `HTML` | `CSS` | `JS`) => void;
  toggleFullScreen: () => void;
  onLoadingChange: (loading: boolean) => void;
  setBackToTab: (tab: AiComponentTab | null) => void;
}

export function useComponentUIState(
  selectedTab: Signal<AiComponentTab>,
  selectedCodeTab: Signal<`HTML` | `CSS` | `JS`>,
  isFullScreen: Signal<boolean>,
  isProcessing: Signal<boolean>,
  backToTab: Signal<AiComponentTab | null>,
): UIStateActions {
  const selectTab = (tab: AiComponentTab) => {
    if (selectedTab.peek() === tab) {
      selectedTab.value = AiComponentTab.PROMPT;
    } else {
      selectedTab.value = tab;
    }
    setBackToTab(selectedTab.peek());
  };

  const onSelectedCodeTab = (tab: `HTML` | `CSS` | `JS`) => {
    selectedCodeTab.value = tab;
  };

  const toggleFullScreen = () => {
    isFullScreen.value = !isFullScreen.value;
  };

  const onLoadingChange = (loading: boolean) => {
    isProcessing.value = loading;
  };

  const setBackToTab = (tab: AiComponentTab | null) => {
    backToTab.value = tab;
  };

  return {
    selectTab,
    onSelectedCodeTab,
    toggleFullScreen,
    onLoadingChange,
    setBackToTab,
  };
}
